module.exports = __webpack_public_path__ + "static/media/kredyt_17.f4f70229.png";